"use client"

import { WalletConnectPrompt } from "@/app/collections/items/user-items/wallet-connect-prompt"
import { CollectionItemsViewReatom } from "@/app/collections/items/view/index.reatom"
import { CollectionSidebar } from "@/app/collections/sidebar/collection-sidebar"
import type { ViewType } from "@/app/nft/search/result/view/view-selector/types"
import { useOwnerUnionAddressForCollection } from "@/app/wallet-connect/hooks"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { reatomComponent } from "@reatom/react"
import { CollectionPage } from "../collection-page"
import { LoadingView } from "../loading/loading-view"
import { CollectionItemsSearchProvider } from "../search-provider"

interface Props {
  initialViewType: ViewType
  collectionId: CollectionId
  toolbar: React.ReactNode
}

export const CollectionUserItemsPageContentReatom = reatomComponent(
  (props: Props) => {
    const { initialViewType, collectionId, toolbar } = props
    const userWalletAddress = useOwnerUnionAddressForCollection(collectionId)

    if (!userWalletAddress)
      return (
        <CollectionPage
          sidebar={null}
          content={<WalletConnectPrompt className="h-full" />}
          toolbar={toolbar}
        />
      )

    return (
      <CollectionItemsSearchProvider
        collectionId={collectionId}
        owner={userWalletAddress}
      >
        <CollectionPage
          sidebar={<CollectionSidebar />}
          content={
            <CollectionItemsViewReatom initialViewType={initialViewType} />
          }
          toolbar={toolbar}
        />
      </CollectionItemsSearchProvider>
    )
  },
  "CollectionUserItemsPageContentReatom",
)
